import { render, staticRenderFns } from "./AddEmailToDistributionListPopup.vue?vue&type=template&id=3108a6d0&scoped=true"
import script from "./AddEmailToDistributionListPopup.vue?vue&type=script&lang=js"
export * from "./AddEmailToDistributionListPopup.vue?vue&type=script&lang=js"
import style0 from "./AddEmailToDistributionListPopup.vue?vue&type=style&index=0&id=3108a6d0&prod&lang=scss&scoped=true"
import style1 from "./AddEmailToDistributionListPopup.vue?vue&type=style&index=1&id=3108a6d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3108a6d0",
  null
  
)

export default component.exports